import React, { useState } from 'react'
import style from './cardEmployeeTooltip.module.scss'
import { IEmployee, IProjectManager } from '../../starter/model/interfaces'
import ItemCard from '../ItemCard/ItemCard'
import dayjs from 'dayjs'
import { DATE_FORMAT, SEX } from '../../starter/constants'
import TextArea from 'antd/es/input/TextArea'

export type TCardEmployeeTooltip = {
  employee: IEmployee
}
const CardEmployeeTooltip = ({ employee }: TCardEmployeeTooltip) => {
  const [tmpPerson, setTmpPerson] = useState<IEmployee | IProjectManager>(employee)
  const handleInputChange = (name: string, value: string): void => {
    setTmpPerson({
      ...tmpPerson,
      [name]: value
    })
  }

  return (
    <div
      className={style.wrapper}
      onClick={(e) => {
        e.stopPropagation()
      }}
      onDoubleClick={(e) => {
        e.stopPropagation()
      }}>
      <ItemCard label={'Имя:'} value={employee.firstName} type={'text'} />
      <ItemCard label={'Фамилия:'} value={employee.lastName} type={'text'} />
      <ItemCard label={'Отчество:'} value={employee.middleName || ''} type={'text'} />
      <ItemCard label={'День рождения:'} value={dayjs(employee.birthDay).format(DATE_FORMAT)} type={'date'} />
      <ItemCard label={'Пол:'} value={employee.sex === 'male' ? SEX.male : SEX.female} type={'sex'} />
      <ItemCard label={'email:'} value={employee.email} type={'text'} />
      <ItemCard label={'phone:'} value={employee.phone} type={'text'} />
      <ItemCard label={'telegram:'} value={employee.telegram} type={'text'} />
      <span>Комментарий:</span>
      <TextArea
        rows={4}
        value={employee.comment}
        name='comment'
        onChange={(e) => {
          handleInputChange('comment', e.target.value)
        }}
      />
    </div>
  )
}

export default CardEmployeeTooltip
